import { gql } from "graphql-request";
import * as z from "zod";
import { ImageSchema, ImageFragment } from "./image";
import { SysSchema, SysFragment } from "./sys";
import {
  CommunityCreatorSchema,
  CommunityCreatorFragment,
} from "./communityCreator";
import { Locale } from "../../locale";

export const CommunityEntrySchema = z.object({
  sys: SysSchema,
  communityCreator: CommunityCreatorSchema.nullish(),
  communityEntryTitle: z.string().nullable(),
  communityEntryVideoUrl: z.string().nullable(),
  communityEntryNewUntil: z.string().nullable(),
  communityEntryVideoLocale: Locale.nullable(),
  communityEntrySubmissionInfo: z.string().nullable(),
  communityEntryVideoThumbnail: ImageSchema.nullable(),
  communityEntryVideoThumbnailEn: ImageSchema.nullable(),
  sortDate: z.string().nullable(),
});

export const CommunityEntry = CommunityEntrySchema;
export type CommunityEntry = z.infer<typeof CommunityEntrySchema>;

export const CommunityEntryFragment = gql`
  fragment CommunityEntryFragment on CommunityVideoEntry {
    sys {
      ...SysFragment
    }
    communityEntryTitle
    communityEntryVideoUrl
    communityEntryNewUntil
    communityEntryVideoLocale
    communityEntrySubmissionInfo
    communityEntryVideoThumbnail {
      ...ImageFragment
    }
    communityEntryVideoThumbnailEn: communityEntryVideoThumbnail(locale: "en") {
      ...ImageFragment
    }
    sortDate
    communityCreator {
      ...CommunityCreatorFragment
    }
  }

  ${CommunityCreatorFragment}
  ${ImageFragment}
  ${SysFragment}
`;
